import "./polyfills";

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { ConnectedRouter } from "connected-react-router";
import { PersistGate } from "redux-persist/es/integration/react";

import configureStore from "./store/configureStore";
import { updateCacheBuster } from "./util/getCacheBuster";
import { getCacheBuster } from "./reducers/session";

import { Route } from "@/router";
import { i18n } from "./i18n";

import "../style/index.less";
import "../style/index.scss";

import LoadingIndicator from "@/common/components/LoadingIndicator";

const { store, persistor, history } = configureStore();

const rootElement = document.getElementById("ek-app");

let render = async () => {
  const AppModule = await import("./app/App");
  const App = AppModule.default;

  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store} key="provider">
        <PersistGate persistor={persistor}>
          <ConnectedRouter history={history}>
            {/* Initial suspense for the translations */}
            <Suspense fallback={<LoadingIndicator />}>
              <React.StrictMode>
                <Route path="/" component={App} />
              </React.StrictMode>
            </Suspense>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    </I18nextProvider>,
    rootElement
  );
};

if (module.hot) {
  const renderApp = render;

  render = async () => {
    try {
      await renderApp();
    } catch (error) {
      console.error(error);
    }
  };

  module.hot.accept("./app/App", () => {
    console.log("[HMR] render app");
    setTimeout(render);
  });
}

// TODO: this should be moved elsewhere
// subscribe to cache buster update
(function attachCacheBusterUpdate() {
  let previousCacheBuster = "";
  store.subscribe(() => {
    const nextCacheBuster = getCacheBuster(store.getState());
    if (nextCacheBuster && previousCacheBuster !== nextCacheBuster) {
      previousCacheBuster = updateCacheBuster(nextCacheBuster);
    }
  });
})();

// render the app
render();
